// extracted by mini-css-extract-plugin
export default {"pie":"donutText_pie__7Q6NI","additionalTextDonut":"donutText_additionalTextDonut__hGPyh","resultsPie":"donutText_resultsPie__lPE1G"};